import React from 'react'

function CallToAction() {
  return (
    <div>
        
        <>
            {/* Start Quick contact area  */}
            <div className="quick-action-area quick-action-style-one">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="quick-action-inner">
                                <div className="quick-action-left">
                                    <p className="description">
                                        Bizper is proud to serve you 24/7. Just Call Us when you need
                                    </p>
                                </div>
                                <div className="quick-action-right">
                                    <div className="contact">
                                        <a className="btn-rounded mid-btn" href="tel:+4733378901">
                                            <i className="fa-solid fa-phone-volume" />
                                        </a>
                                        <div className="content">
                                            <h3 className="title">Contact us to</h3>
                                            <a className="ph-number" href="tel:+4733378901">
                                                +01234568906
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dot-top">
                    <div className="thumbnail">
                        <img src="assets/images/quick-action/1.png" alt="dot" />
                    </div>
                </div>
                <div className="carly-line">
                    <div className="thumbnail">
                        <img src="assets/images/quick-action/carly-line.png" alt="" />
                    </div>
                </div>
                <div className="dot-bottom">
                    <div className="thumbnail">
                        <img src="assets/images/quick-action/1.png" alt="dot" />
                    </div>
                </div>
                <div className="shape">
                    <div className="thumbnail">
                        <img src="assets/images/quick-action//quick-action-1.png" alt="dot" />
                    </div>
                </div>
                <div className="shape-2">
                    <div className="thumbnail">
                        <img src="assets/images/quick-action/shape-2.png" alt="dot" />
                    </div>
                </div>
            </div>
            {/* End Quick contact area  */}
        </>

    </div>
  )
}

export default CallToAction